/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { AttendeeResponseType } from '../enums/attendee-response-type';
export class CalendarEventEntity extends Entity {
  adhocEmail: string | null = null;
  adhocFirstName: string | null = null;
  adhocLastName: string | null = null;
  attendeeResponse: AttendeeResponseType | null = null;
  busy: boolean = false;
  calendarId: string | null = null;
  candidateId: string | null = null;
  contactId: string | null = null;
  endTime: string | null = null;
  id: string = '';
  startTime: string | null = null;
  title: string | null = null;
  accountName?: string | null = null;
  static override key = 'CalendarEvent';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CalendarEvent' in input
    ) {
      const { CalendarEvent: wrapped, ...rest } = input as {
        CalendarEvent: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}